export const SITE_BUILDER_COUNTDOWN_LABELS = Object.freeze({
    "ui.countdown.days": Object.freeze({
        cs: "Dny",
        sk: "Dni",
        en: "Days",
        de: "Tage",
        es: "Días",
        pl: "Dni",
        hu: "Nap",
        ro: "Zile",
    }),
    "ui.countdown.hours": Object.freeze({
        cs: "Hod.",
        sk: "Hod.",
        en: "Hrs",
        de: "Std.",
        es: "H",
        pl: "Godz.",
        hu: "Óra",
        ro: "Ore",
    }),
    "ui.countdown.minutes": Object.freeze({
        cs: "Min.",
        sk: "Min.",
        en: "Min",
        de: "Min.",
        es: "Min",
        pl: "Min",
        hu: "Perc",
        ro: "Min",
    }),
    "ui.countdown.seconds": Object.freeze({
        cs: "Sek.",
        sk: "Sek.",
        en: "Sec",
        de: "Sek.",
        es: "S",
        pl: "Sek.",
        hu: "Mp",
        ro: "Sec",
    }),
});
